declare namespace $ {

	type __shm_hitalama_draglist_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_draglist['dragged'] >[0]
		,
		Parameters< $shm_hitalama_draglist['Drag'] >[0]
	>
	type $mol_view__sub_shm_hitalama_draglist_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_draglist_item__on_drag_start_shm_hitalama_draglist_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_draglist['on_drag_start'] >
		,
		ReturnType< $shm_hitalama_draglist_item['on_drag_start'] >
	>
	type $shm_hitalama_draglist_item__on_drag_end_shm_hitalama_draglist_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_draglist['on_drag_end'] >
		,
		ReturnType< $shm_hitalama_draglist_item['on_drag_end'] >
	>
	type $shm_hitalama_draglist_item__top_shm_hitalama_draglist_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_draglist['y'] >
		,
		ReturnType< $shm_hitalama_draglist_item['top'] >
	>
	type $shm_hitalama_draglist_item__left_shm_hitalama_draglist_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_draglist['x'] >
		,
		ReturnType< $shm_hitalama_draglist_item['left'] >
	>
	type $shm_hitalama_draglist_item__sub_shm_hitalama_draglist_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_draglist_item['sub'] >
	>
	export class $shm_hitalama_draglist extends $mol_view {
		on_drag_start( id: any, next?: any ): any
		on_drag_end( id: any, next?: any ): any
		dragged( id: any): ReturnType< ReturnType< $shm_hitalama_draglist['Drag'] >['dragged'] >
		y( id: any, next?: number ): number
		x( id: any, next?: number ): number
		id( id: any): string
		Item( id: any): $mol_view
		Drag( id: any): $shm_hitalama_draglist_item
		some_dragged( ): boolean
		ids( next?: readonly(any)[] ): readonly(any)[]
		ids_ordered( next?: readonly(any)[] ): readonly(any)[]
		remove_area_active( next?: boolean ): boolean
		items( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=draglist.view.tree.d.ts.map